@if (!faqRevampSwitch) {
<div class="modal-content">
  <div class="modal-header">
    <h1 class="modal-title pull-left" id="my-modal-title">
      {{ "FAQS" | globalTranslate }}
    </h1>
    <button type="button" class="btn-close pull-right" aria-label="Close" (click)="onCancel()">
      <img src="../../assets/images/⚛️ icons-close-circle-outline.svg" alt="close-icon" />
    </button>
  </div>
  <div class="modal-body">
    <div id="accordion">
      @for (itemPar of data; track itemPar) { @for (item of itemPar.questions;
      track item; let i = $index) {
      <div class="card card-background p-3" (click)="cardClickHandler($event, item)">
        @if (i === 0) {
        <div class="pb-3">
          <h2 class="section-header">{{ itemPar.header | globalTranslate }}</h2>
          <hr />
        </div>
        }
        <h2 attr.aria-label="collapse{{ item.key | globalTranslate }}">
          <div data-toggle="collapse" attr.data-target="#collapse{{ item.key | globalTranslate }}">
            <div class="d-flex align-items-center">
              <div class="item-key">
                <strong>{{ item.key | globalTranslate }}</strong>
              </div>
              @if (item.show) {
              <div class="ms-3 item-key-symbol">
                <i class="fa fa-angle-up"></i>
              </div>
              } @if (!item.show) {
              <div class="ms-3 item-key-symbol">
                <i class="fa fa-angle-down"></i>
              </div>
              }
            </div>
          </div>
        </h2>
        <div id="collapse{{ i }}" [ngClass]="{ show: item.show }" class="collapse" aria-labelledby="headingOne"
          data-bs-parent="#accordion">
          <div class="card-body">
            <div [innerHtml]="item.value | globalTranslate"></div>
          </div>
        </div>
      </div>
      } }
    </div>
  </div>
</div>
}

<!-- New FAQ Revamp Design -->
@if (faqRevampSwitch) {
<div class="modal-content faq-revamp-modal">
  <div class="modal-header">
    <h1 class="modal-title pull-left" id="my-modal-title">
      @if (showCategoryView && this.language === 'sp') {
      {{ "FAQ_HEADER_TEXT" | globalTranslate }}
      } @if (showCategoryView && this.language !== 'sp') {
      {{ "FAQ_HEADER_TEXT" | globalTranslate }} <span>({{ "FAQs" }})</span>
      } @if (!showCategoryView && selectedCategory) {
      {{ selectedCategory.title | globalTranslate }}
      }
    </h1>
    <button type="button" class="btn-close pull-right" aria-label="Close" (click)="onCancel()">
      <img src="../../assets/images/⚛️ icons-close-circle-outline.svg" alt="close-icon" />
    </button>
  </div>
  <div class="modal-body">
    <!-- Category View -->
    @if (showCategoryView) {
    <p class="faq-search-instruction">
      {{ "FAQ_SEARCH_INSTRUCTION" | globalTranslate }}
    </p>
    <!-- Search Section -->
    <div class="faq-search-section" role="search">
      <div class="search-input-wrapper">
        <p class="search-label">
          <strong>{{ "FAQ_SEARCH_LABEL" | globalTranslate }}</strong>
        </p>
        <div class="search-input-container">
          <input type="search" id="mobileFaqSearchInput" class="faq-search-input"
            [placeholder]="'FAQ_SEARCH_PLACEHOLDER' | globalTranslate" [(ngModel)]="searchQuery"
            (input)="onSearchInput($event)" [attr.aria-label]="'FAQ_SEARCH_LABEL' | globalTranslate" />
          @if (searchQuery) {
          <button type="button" class="faq-search-clear-btn" (click)="clearSearch()" [attr.aria-label]="'Clear search'">
            <i class="fa fa-times" aria-hidden="true"></i>
          </button>
          }
        </div>
        <hr />
      </div>
    </div>
    <!-- No Results Message -->
    @if (isSearching && searchResults.length === 0) {
    <div class="faq-no-results">
      <p>{{ "FAQ_NO_RESULTS_MESSAGE" | globalTranslate }}</p>
    </div>
    }
    <!-- Search Results -->
    @if (isSearching && searchResults.length > 0) {
    <div class="faq-search-results">
      <div id="mobileSearchAccordion">
        @for (item of searchResults; track item; let i = $index) {
        <div class="faq-question-item">
          <div class="faq-question-header" role="button" tabindex="0" [attr.aria-expanded]="item.show"
            [attr.aria-label]="
              (item.key | globalTranslate) +
              (item.show
                ? ', ' + ('EXPANDED' | globalTranslate)
                : ', ' + ('COLLAPSED' | globalTranslate))
            " [attr.aria-controls]="'mobileSearchCollapse' + i" (click)="showHide(item)"
            (keydown.enter)="showHide(item)" (keydown.space)="showHide(item); $event.preventDefault()">
            <div class="d-flex align-items-start">
              <p class="item-key">
                <strong>{{ item.key | globalTranslate }}</strong>
              </p>
              @if (item.show) {
              <div class="ms-3 item-key-symbol arrow" aria-hidden="true">
                <i class="fa fa-angle-up"></i>
              </div>
              } @if (!item.show) {
              <div class="ms-3 item-key-symbol arrow" aria-hidden="true">
                <i class="fa fa-angle-down"></i>
              </div>
              }
            </div>
          </div>
          <div [id]="'mobileSearchCollapse' + i" [ngClass]="{ show: item.show }" class="collapse"
            aria-labelledby="headingOne" data-bs-parent="#mobileSearchAccordion">
            <div class="card-body">
              <p [innerHtml]="item.value | globalTranslate"></p>
            </div>
          </div>
          @if (i
          < searchResults.length - 1) { <hr [style.margin-top]="item.show ? '41px' : '13px'" />
          }
        </div>
        }
      </div>
    </div>
    } @if (!isSearching) {
    <div class="faq-browse-categories">
      <h2>{{ "FAQ_BROWSE_CATEGORIES" | globalTranslate }}</h2>
      <p>{{ "FAQ_BROWSE_CATEGORIES_MESSAGE" | globalTranslate }}</p>
    </div>
    }
    <!-- Category Tiles -->
    @if (!isSearching) {
    <div class="faq-categories-grid" role="list">
      @for (category of categories; track category) {
      <div class="faq-category-card" role="listitem" tabindex="0" (click)="onCategoryClick(category.id)"
        (keydown.enter)="onCategoryClick(category.id)"
        (keydown.space)="onCategoryClick(category.id); $event.preventDefault()"
        [attr.aria-label]="category.title | globalTranslate">
        <div class="category-content">
          <div class="category-icon" aria-hidden="true">
            <img [src]="category.icon" alt="" />
          </div>
          <h3 class="category-title">{{ category.title | globalTranslate }}</h3>
        </div>
      </div>
      }
    </div>
    } }
    <!-- Questions View -->
    @if (!showCategoryView && selectedCategory) {
    <div class="faq-questions-view">
      <!-- Back Button -->
      <div class="faq-back-section mb-3">
        <button type="button" class="faq-back-btn" (click)="goBackToCategories()"
          [attr.aria-label]="('FAQ_BACK_TO_CATEGORIES' | globalTranslate) + (language === 'en' ? ' (FAQs)' : '')">
          <svg xmlns="http://www.w3.org/2000/svg" width="16.875" height="15.75" viewBox="0 0 16.875 15.75">
            <g id="_icons_arrow-back-outline" data-name="⚛️ icons/arrow-back-outline" transform="translate(0)">
              <path id="Combined_Shape" data-name="Combined Shape"
                d="M7.093,15.434l-.014-.014L.329,8.671A1.126,1.126,0,0,1,.316,7.093l.014-.014L7.079.329a1.125,1.125,0,0,1,1.6,1.578l-.014.013L3.841,6.75H15.75A1.125,1.125,0,0,1,15.769,9H3.841l4.829,4.829a1.126,1.126,0,0,1,.014,1.578l-.014.013a1.126,1.126,0,0,1-1.578.014Z"
                transform="translate(0)" fill="#174a7c" />
            </g>
          </svg>
          <span class="span-back-btn">{{
            "FAQ_BACK_TO_CATEGORIES" | globalTranslate}}{{ language === 'en'? ' (FAQs)' : ''}}
          </span>
        </button>
      </div>
      <!-- Questions List -->
      <div id="mobileFaqAccordion">
        @for (item of filteredQuestions; track item; let i = $index) {
        <div class="faq-question-item">
          @if (isAppealCategorySelected() &&
          isEligibilityAppealsHeader(item.key)) {
          <h2 class="faq-sub-heading">
            {{ "MY_ELIGIBILITY_APPEALS" | globalTranslate }}
          </h2>
          } @if (isEligibilityAppealsHeader(item.key)) {
          <hr class="faq-sub-heading-divider" />
          } @if (isAppealCategorySelected() && isMedicalAppealsHeader(item.key) && medicalAppealsSwitch)
          {
          <h2 class="faq-sub-heading medical-appeals-subheading">
            {{ "MY_SUBMISSIONS_MA_HEADER" | globalTranslate }}
          </h2>
          } @if (isMedicalAppealsHeader(item.key) && medicalAppealsSwitch) {
          <hr class="faq-sub-heading-divider" />
          }
          <div class="faq-question-header" role="button" tabindex="0" [attr.aria-expanded]="item.show"
            [attr.aria-label]="
              (item.key | globalTranslate) +
              (item.show
                ? ', ' + ('EXPANDED' | globalTranslate)
                : ', ' + ('COLLAPSED' | globalTranslate))
            " [attr.aria-controls]="'mobileFaqCollapse' + i" (click)="showHide(item)" (keydown.enter)="showHide(item)"
            (keydown.space)="showHide(item); $event.preventDefault()">
            <div class="d-flex align-items-start">
              <p class="item-key">
                <strong [innerHtml]="item.key | globalTranslate"></strong>
              </p>
              @if (item.show) {
              <div class="ms-3 item-key-symbol arrow" aria-hidden="true">
                <i class="fa fa-angle-up"></i>
              </div>
              } @if (!item.show) {
              <div class="ms-3 item-key-symbol arrow" aria-hidden="true">
                <i class="fa fa-angle-down"></i>
              </div>
              }
            </div>
          </div>
          <div [id]="'mobileFaqCollapse' + i" [ngClass]="{ show: item.show }" class="collapse"
            aria-labelledby="headingOne" data-bs-parent="#mobileFaqAccordion">
            <div class="card-body">
              <p
                [innerHtml]="item.value === 'FAQ_VALUE_46' ? (formatFaqAnswer(item.value) | globalTranslate) : (item.value | globalTranslate)">
              </p>
            </div>
          </div>
          @if (i
          < filteredQuestions.length - 1 && !isEligibilityAppealsHeader(filteredQuestions[i + 1]?.key) &&
            !isMedicalAppealsHeader(filteredQuestions[i + 1]?.key)) { <hr
            [style.margin-top]="item.show ? '41px' : '13px'" />
          }
        </div>
        }
      </div>
    </div>
    }
  </div>
</div>
}